import React from 'react'
import logo from '../ui/logo.svg'
import apple from '../ui/Apple Store.svg'
import qr from '../ui/QR_to_App.png'
import './arAppAd.css'






function ArAppAd() {
    return (
        <div>

            <div id='container'>

                <p>
                    {/* <img src={backgroundImg} alt="hinterundsbild für eine Werbung für die AR-App" id='imgBackground' /> */}

                </p>

                <div id='content'>

                    <div className='description'>
                        <div id=''>

                            <p id='content_text'>
                                App zur Aufarbeitung der Geländegeschichte
                                <br />
                                während des Nationalsozialismus

                            </p>
                        </div>


                    </div>

                    <div>
                        <div className='arApAdLogo'>
                            <img src={logo} alt="" />
                        </div>
                    </div>



                    <div id='link_to_app'>
                        <div>
                            <a href="https://apps.apple.com/de/app/k-aleidoskop/id6683290171" target='_blank' rel="noopener noreferrer">
                                <img src={apple} alt="" />


                            </a>

                        </div>

                        <div>
                            <img src={qr} alt="" />
                        </div>



                    </div>



                </div>

            </div>






        </div>
    )
}

export default ArAppAd